import axios from "axios";
import { store } from "./index";
import SETTINGS from "../settings.js";
import { addErrorAlert } from "./calls/alertLoadingDispatch";
import * as actions from "./actions";

const ax = axios.create({
  baseURL: SETTINGS.apiUrl
});

// Set default CORS and Content Type headers, add the JWT token if present.
ax.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    };

    // add the token;
    const state = store.getState();
    const accessToken = state.user.token;
    if (accessToken && accessToken.length) {
      config.headers.Authorization = "Bearer " + accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ax.interceptors.response.use(
  (response) => response, // just give us the goods if request is fulfilled

  (error) => {
    // default error handlers here. Kick people out if we get to a 401.
    const originalRequest = error.config;
    let state = store.getState();

    if (!error.response) return Promise.reject(error);

    if (
      error.response.status === 401 &&
      !error.config.url.includes("token") // don't redirect callbacks from our token endpoint
    ) {
      window.location.href = "/login";
    }

    

    if (error.response.status === 403) {
      addErrorAlert("You don't have the permissions to do that.")
    }
    return Promise.reject(error);
  }
);

export {ax as customAxios}

export default {
  get(url, params) {
    return ax
      .get(url, { params })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  post(url, request) {
    return ax
      .post(url, { ...request })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  patch(url, request) {
    return ax
      .patch(url, { ...request })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },

  delete(url, params) {
    return ax
      .delete(url, { params })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  },
};
